import { render, staticRenderFns } from "./categoryproject.html?vue&type=template&id=5109b274&scoped=true&"
import script from "./categoryproject.js?vue&type=script&lang=js&"
export * from "./categoryproject.js?vue&type=script&lang=js&"
import style0 from "./categoryproject.css?vue&type=style&index=0&id=5109b274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109b274",
  null
  
)

export default component.exports